;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="6c49145d-03a3-4f3a-9065-da6cf893891d",e._sentryDebugIdIdentifier="sentry-dbid-6c49145d-03a3-4f3a-9065-da6cf893891d")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

function isInSameCategoryTree(categoryPath, highlightPath) {
    let active = false;
    if (highlightPath?.startsWith(categoryPath)) {
        active = true;
        const hightlightPathArr = highlightPath.split('/');
        categoryPath.split('/').forEach((categoryPathValue, index) => {
            if (categoryPathValue !== hightlightPathArr[index]) {
                active = false;
            }
        });
    }
    return active;
}
function convertUiCategory(category, highlightPath) {
    function mapToExt(categories) {
        return categories?.map((child) => convertUiCategory(child, highlightPath));
    }
    return {
        ...category,
        active: isInSameCategoryTree(category.path, highlightPath),
        children: mapToExt(category.children),
        specials: mapToExt(category.specials),
    };
}
function convertToHeaderContent({ headerServiceResponse, isNextJS, highlightPath, }) {
    return {
        ...headerServiceResponse,
        categories: headerServiceResponse.categories?.map((category) => convertUiCategory(category, highlightPath)) ?? [],
        isNextJS,
    };
}

export { convertToHeaderContent, isInSameCategoryTree };
//# sourceMappingURL=contentConverter.js.map
